import { CalendarDate } from '@internationalized/date';
import {
  CreateInvoiceInput,
  InvoiceType,
  PaymentTerm,
  InvoiceLineItemInput,
  MoneyInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type InvoiceCreateParams = {
  type: InvoiceType;
  documentNumber?: string;
  documentDate: CalendarDate;
  accountId: string;
  facilityId: string;
  paymentTerm: PaymentTerm;
  notes?: string | null;
  amount: MoneyInput;
  lineItems?: InvoiceLineItemInput[];
};

export const invoiceCreateAtom = createMutationAtomFactory(
  'finance.invoiceCreate',
  (params: InvoiceCreateParams) => {
    const input: CreateInvoiceInput = {
      type: params.type,
      documentDate: params.documentDate.toString(),
      accountID: params.accountId,
      facilityID: params.facilityId,
      paymentTerm: params.paymentTerm,
      amount: params.amount,
    };

    if (params.documentNumber) {
      input.documentNumber = params.documentNumber;
    }
    if (params.notes) {
      input.notes = params.notes;
    }
    if (params.lineItems) {
      input.lineItems = params.lineItems;
    }

    return {
      financeInvoiceCreate: {
        __args: {
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
